import {
  ExpandMore,
  PictureAsPdf,
  VerifiedUserOutlined,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import timezone from "dayjs/plugin/timezone";
import dayjs, { utc } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const JobAuthorizeComponent = ({
  colors,
  isNonMobile,
  data,
  loading,
  setSelectedRequestId,
  handleOpenReportPreview,
  approveDate,
  setApproveDate,
  setOpenConfirmDialog,
  setCheckedReport,
  setConfirmMessage,
}) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Box display="flex" justifyContent="space-between" width="100%">
          <Typography
            component="span"
            variant="h4"
            fontWeight={600}
            color={colors.grey[600]}
          >
            {data.labRequest
              ? "QC/" +
                data.reportType +
                "/" +
                data.labRequest.year +
                "/" +
                String(data.id).padStart(4, "0")
              : ""}
          </Typography>
          <Typography
            component="span"
            variant="h4"
            fontWeight={600}
            color="info"
          >
            {data.labRequest
              ? "JOB/" +
                data.labRequest.year +
                "/" +
                String(data.labRequest.id).padStart(4, "0")
              : ""}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Card
          variant="elevation"
          elevation={4}
          sx={{
            // border:
            //   paid === true
            //     ? `${colors.greenAccent[500]} solid thin`
            //     : `red solid thin`,
            width: "100%",
            marginBottom: "6px",
            padding: "5px",
            //   backgroundColor: colors.grey[900],
          }}
        >
          <CardContent style={{ paddingBottom: "2px" }}>
            <Box
              display="grid"
              gap="8px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              <Box
                sx={{
                  gridColumn: "span 5",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ width: "100%" }}
                >
                  <Box display="flex" justifyContent="space-between">
                    <Box display="flex" gap={2}>
                      <Typography variant="h5" fontWeight="400">
                        Project
                      </Typography>
                      <Typography
                        variant="h5"
                        color="success"
                        fontStyle="italic"
                      >
                        {data.labRequest.project}
                      </Typography>
                    </Box>
                    <Typography variant="h4" color={colors.redAccent[600]}>
                      Job No :{" "}
                      {data.labRequest.year +
                        "/" +
                        String(data.labRequest.id).padStart(4, "0")}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h5" fontWeight="400">
                      Test name
                    </Typography>
                    <Typography variant="h5" fontStyle="italic" color="success">
                      {data.labRequest.labRequestTests[0].labTest.testName}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 2",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {loading ? (
                  <CircularProgress
                    sx={{
                      color: colors.greenAccent[500],
                      position: "absolute",
                      zIndex: 10,
                    }}
                  />
                ) : (
                  ""
                )}
              </Box>
              <Divider sx={{ gridColumn: "span 5" }} />
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Job register date</Typography>
                <Typography variant="h5" color="success">
                  {data.labRequest.regDate}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Institute</Typography>
                <Typography variant="h5" color="success">
                  {data.labRequest.institute.instituteName}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Report date</Typography>
                <Typography variant="h5" color="success">
                  {data.date}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Email</Typography>
                <Typography variant="h5" color="success">
                  {data.labRequest.institute.email}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                  paddingBottom: "5px",
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label="Date"
                      format="YYYY-MM-DD"
                      sx={{ width: "100%" }}
                      timezone="Asia/Colombo"
                      value={
                        approveDate
                          ? dayjs(approveDate).tz("Asia/Colombo", true)
                          : dayjs(new Date()).tz("Asia/Colombo", true)
                      }
                      onChange={(newValue) => {
                        const colomboTime = newValue?.tz("Asia/Colombo", true);
                        setApproveDate(dayjs(colomboTime).format("YYYY-MM-DD"));
                      }}
                      slotProps={{
                        textField: {
                          variant: "outlined",
                          size: "small",
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Box>
            </Box>
          </CardContent>
          <Divider />
          <CardActions
            sx={{
              margin: 0,
              paddingTop: "0px",
              paddingBottom: "0px",
              justifyContent: "space-between",
            }}
          >
            <Box display="flex" alignItems="center">
              <Typography
                variant="h5"
                fontWeight={600}
                color={colors.redAccent[600]}
              >
                {data.labRequest
                  ? "QC/" +
                    data.reportType +
                    "/" +
                    data.labRequest.year +
                    "/" +
                    String(data.id).padStart(4, "0")
                  : ""}
              </Typography>
              <Tooltip title="View Report">
                <IconButton
                  aria-label="add an alarm"
                  onClick={() => {
                    console.log("ggg", data);
                    setSelectedRequestId(data);
                    handleOpenReportPreview();
                  }}
                >
                  <PictureAsPdf color="info" sx={{ fontSize: "25px" }} />
                </IconButton>
              </Tooltip>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography
                sx={{ marginRight: "20px" }}
                fontWeight={"600"}
                color="info"
                variant="h3"
              >
                LKR{" "}
                {data.labRequest.grandTotal.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })}
              </Typography>
              <Button
                type="button"
                loading={loading}
                startIcon={<VerifiedUserOutlined />}
                color="success"
                variant="contained"
                onClick={() => {
                  setCheckedReport("APPROVE");
                  setSelectedRequestId(data);
                  setConfirmMessage(
                    "Are you sure you want to approve the report?"
                  );
                  setOpenConfirmDialog(true);
                }}
              >
                AUTHORIZE REPORT
              </Button>
              <Button
                type="button"
                loading={loading}
                startIcon={<VerifiedUserOutlined />}
                color="error"
                variant="contained"
                onClick={() => {
                  setCheckedReport("REJECT REPORT");
                  setSelectedRequestId(data);
                  setConfirmMessage(
                    "Are you sure you want to reject the report?"
                  );
                  setOpenConfirmDialog(true);
                }}
              >
                REJECT REPORT
              </Button>
            </Box>
          </CardActions>
        </Card>
      </AccordionDetails>
    </Accordion>
  );
};
export default JobAuthorizeComponent;
